/* eslint-disable max-len */
// ==============================================
// ==================Import======================
// ==============================================

// ==================Style&IMG===================
import './style.scss';

// =================Material UI==================
import {
  Backdrop,
  Box,
  Fade,
  Modal,
  Typography,
} from '@mui/material';

// =================React Hook==================
import { useSelector, useDispatch } from 'react-redux';

// =================Actions==================
import { setOpenSafariModal } from '../../../actions/header';

function SafariModal() {
// ==================HOOK=========================
  const dispatch = useDispatch();
  const openSafariModal = useSelector(
    (state) => state.header.modal.safariModal,
  );
  // ==================handler=========================
  const handleCloseSafariModal = () => {
    dispatch(setOpenSafariModal(false));
  };

  return (
    <Modal
      open={openSafariModal}
      onClose={handleCloseSafariModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 600,
        },
      }}
    >
      <Fade in={openSafariModal}>
        <Box className="commandLineClient--modal">
          <Typography id="modal-modal-title" variant="h4" component="h2">
            Browser issue
          </Typography>
          <Box className="commandLineClient--modal__text">
            <p>
              ⚠️ An issue prevents the safari browser to works correctly on this website. Until this is resolved please use Firefox, or Chrome. ⚠️
            </p>
            <p>
              Thank you for the understanding.
            </p>
            <p>
              The EPOS-GNSS Data Gateway Team
            </p>
            <div className="commandLineClient--modal__text--button">
              <button className="commandLineClient--modal__text--button__close" type="button" onClick={handleCloseSafariModal}>Close</button>
            </div>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}

export default SafariModal;
